import ReactGA from 'react-ga4';
import config from '../config';

const state = {
  currentPage: '',
  userID: '',
  userEmail: '',
  appVersion: config.get('version') || '',
  appId: '',
  appName: 'mhub-book-web',
};

const trackPage = (page, options = {}) => {
  ReactGA.send({
    hitType: 'pageview',
    page,
    ...options,
  });
  // ReactGA.event('location_change', {
  //   page,
  //   ...options,
  // });
};

export const googleAnalytics = store => next => (action) => {
  const payload = store.getState();
  if (payload && payload.auth && payload.auth.id) state.userID = payload.auth.id;
  if (payload && payload.auth && payload.auth.email) state.userEmail = payload.auth.email;
  if (
    payload &&
    payload.auth &&
    payload.auth.company &&
    payload.auth.company.id
  ) state.appId = payload.auth.company.id;
  if (action.type === '@@router/LOCATION_CHANGE') {
    const nextPage = `${action.payload.pathname}${action.payload.search}`;
    if (!(state.currentPage === nextPage || nextPage === `${action.payload.pathname}?`)) {
      state.currentPage = nextPage;
      trackPage(nextPage, { user_id: state.userID });
    }
  }
  return next(action);
};



// WEBPACK FOOTER //
// ./src/googleAnalytics.js